import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';
import { Autocomplete, TextField } from '@mui/material';



const Add_table = ({ show, toggle, refreshData, AddcurrentPage }) => {
  const [data2, setData2] = useState([]);
  const token = authServices.getToken();

  const fetchUnit = async () => {
    try {
      const response = await apiClient.get(`/api/admin/unit/getAll`,
        {
          params: {
            pageNumber: 0,
            pageSize: 200
          },
          headers: {
            'access_token': token,
          }
        }
      );
      setData2(response.data.data.records);

    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const filteredData2 = Array.from(
    new Map(data2.map((item) => [item.name, item])).values()
  );

  const validData2 = filteredData2.filter((item) => item.name);

  const [formData, setFormData] = useState({

    portType: '',
    // unitId: '',

  });
  const [errors, setErrors] = useState({}); // Error state
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear the error for the field being edited
    setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    let formErrors = {};

    if (formData.portType === '') {
      formErrors.portType = 'portType cannot be empty';
    }
    // if (formData.unitId === '') {
    //   formErrors.unitId = 'unitId cannot be empty';
    // }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; // No errors
  };

  console.log(formData)

  const handleSubmit = async (e) => {
    // e.preventDefault();
    if (!validateForm()) {
      return; // Stop submission if there are validation errors
    }

    loader('enable');

    try {

      const response = await apiClient.post('/api/admin/port_type/add', formData, {

        headers: {
          'access_token': token,
        },

      });
      if (response.data.Status === "SUCCESS") {

        setFormData({
          portType: '',
          // unitId: '',

        });
      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      loader('disable');
      toggle(); // Close the modal after submission
      // window.location.reload();
    }
  };

  useEffect(() => {
    fetchUnit()
  }, [])


  return (
    <>
      {show && (
        <>
          <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalScrollableTitle">Add Port_Type</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle} >< RxCross2 /></button>
                </div>
                <div className="modal-body-custom">
                  <form >
                  {/* <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="unit" className="label-custom">Unit</label>
                      <Autocomplete
                        className={` ${errors.Unit ? 'input-error' : ''}`}
                        disablePortal
                        options={validData2} // Full user object
                        getOptionLabel={(option) => option.name} // Show 'name' in dropdown
                        getOptionSelected={(option, value) => option.id === value.id} // Ensure unique selection
                        renderInput={(params) => <TextField {...params} label="" />}
                        onChange={(event, value) => {
                          if (value) {
                            setFormData({ ...formData, Unit: value.id }); // Save 'id' in state
                          } else {
                            setFormData({ ...formData, Unit: "" }); // Reset state 
                          }
                        }}
                        // Key attribute setup using 'id'
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            {option.name}
                          </li>
                        )}
                        // Scroll enable kare inline style ke sath
                        componentsProps={{
                          paper: {
                            style: {
                              maxHeight: '110px', // Dropdown ki maximum height
                              overflowY: 'auto',  // Scroll enable karega
                            },
                          },
                        }}
                      />
                    </div> */}

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="portType" className="label-custom">Port Type</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.name ? 'input-error' : ''}`}
                        id="portType"
                        name="portType"
                        value={formData.portType}
                        onChange={handleChange}
                      />
                    </div>

                    

                  </form>
                </div>

                <div className="modal-footer">

                  <button type="button" style={{ backgroundColor: '#F0F0F0', color: '#000', fontWeight: '500', border: "1px solid #d7dde2" }} className="btn " data-bs-dismiss="modal" onClick={toggle}>
                    Close
                  </button>
                  <button type="button" style={{ color: 'white', fontWeight: '500' }} className="btn btn-primary" onClick={handleSubmit}>
                    Submit
                  </button>

                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
          {/* /.modal */}
        </>
      )}
    </>
  );
};

export default Add_table;
